import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  public Msgs: string[] = [];

  public LoadSubject = new Subject<boolean>();

  constructor() { }

  // In future we can add small text below

  public Load() {
    this.LoadSubject.next(true);
  }

  public FinishLoad() {
    this.Initialize();
  }

  public Initialize() {
    this.LoadSubject.next(false);
  }

  /*public UnloadAll() {
    this.Initialize();
  }*/

}
